import { useState } from 'react';

/**
 * Hook to manage modal state for EscalatedQueries page
 * @returns {Object} Modal state and handlers
 */
export const useEscalatedQueriesPageModals = () => {
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedQuery, setSelectedQuery] = useState(null);

  const handleOpenViewModal = (query) => {
    setSelectedQuery(query);
    setViewModalOpen(true);
  };

  const handleCloseViewModal = () => {
    setViewModalOpen(false);
    setSelectedQuery(null);
  };

  return {
    viewModalOpen,
    selectedQuery,
    setViewModalOpen,
    setSelectedQuery,
    handleOpenViewModal,
    handleCloseViewModal,
  };
};
